import { widgetConfig } from "../../utils/config/widgetReportConfig";
import { reportConfig } from "../../utils/config/tableReportConfig";
import { useEffect, useMemo, useState, useCallback } from "react";
import { config as customConfig } from "../../config/Constants";
import { getDynamicSelectData } from "../../utils/api/data";
import Cookies from "js-cookie";
import Axios from 'axios';

export function useReportData(reportName, pageSize, params={}) {
  const [rowsDisplayed, setRowsDisplayed] = useState(0);
  const [data, setData] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const config = useMemo(() => {
    if (!reportName) return null;
    const name = reportName.toLowerCase();
    return widgetConfig[name] || reportConfig[name] || null;
  }, [reportName]);

  const paramsKey = useMemo(() => JSON.stringify(params ?? {}), [params]);

  useEffect(() => {
    if (!config) return;
    (async () => {
      if (Cookies.get("cp-cn") !== "GTMS-CP") {
      const whereValue = 
        typeof config.getWhereValue === 'function'
          ? config.getWhereValue(params)
          : config.whereValue || [];

        const res = await getDynamicSelectData({
          selectValues: config.selectValues,
          tableName: config.tableName,
          whereField: config.whereField,
          whereOperators: config.whereOperators,
          whereValue,
          orderBy: config.orderBy,
          offset: { rowsDisplayed, pageSize },
          db: config.db,
        });
        setData({ data: res });
      } else {
        const r = await Axios.get(customConfig.url.GET_REPORT, { params: { reportName, companyName: Cookies.get("cp-cn") }});
        setData({ data: r.data.report });
      }
    })();
  }, [config, rowsDisplayed, pageSize, paramsKey, refreshKey]);

  const nextPage = () => setRowsDisplayed(n => n + pageSize);
  const resetPaging = () => setRowsDisplayed(0);
  const refresh = useCallback(() => {setRefreshKey(k => k + 1); }, []);


  return { data, rowsDisplayed, nextPage, resetPaging, refresh };
}